import React, { useEffect, useState } from 'react';
import { appDataCacheUtils } from '../core';

export function LoadingPanel({
  title,
  appId,
  subtitle,
  showAppName = true,
  appName = null,
  allowFetch = true,
  progress = null,
  statusMessage = null,
}) {
  const [resolvedAppName, setResolvedAppName] = useState(() => {
    if (appName) return appName;
    return appDataCacheUtils.getAppName(appId);
  });
  const [loadingAppName, setLoadingAppName] = useState(false);

  useEffect(() => {
    if (!appId || !showAppName) {
      setResolvedAppName(null);
      setLoadingAppName(false);
      return;
    }

    if (appName) {
      setResolvedAppName(appName);
      setLoadingAppName(false);
      return;
    }

    const cachedName = appDataCacheUtils.getAppName(appId);
    if (cachedName) {
      setResolvedAppName(cachedName);
      setLoadingAppName(false);
      return;
    }

    if (!allowFetch) {
      setResolvedAppName(null);
      setLoadingAppName(false);
      return;
    }

    setResolvedAppName(null);
    setLoadingAppName(true);
    // Fetch app name from shared cache to avoid duplicate calls
    appDataCacheUtils
      .fetchAppData(appId)
      .then((result) => {
        if (result?.ok && result?.data?.app?.name) {
          setResolvedAppName(result.data.app.name);
        }
      })
      .catch((error) => {
        console.warn('Failed to fetch app name for loading panel:', error);
      })
      .finally(() => {
        setLoadingAppName(false);
      });
  }, [appId, showAppName, appName, allowFetch]);

  return (
    <div className="loading-panel">
      <div className="loading-spinner"></div>
      <div className="loading-content">
        <h2 className="loading-title">{title}</h2>
        {showAppName && appId && (
          <div className="loading-app-name">
            {loadingAppName ? 'Loading...' : (resolvedAppName || `App ${appId}`)}
          </div>
        )}
      </div>
      {progress != null && (
        <div className="loading-progress-container">
          <div className="loading-progress-track">
            <div
              className="loading-progress-fill"
              style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
            />
          </div>
          {statusMessage && (
            <p className="loading-status-message">{statusMessage}</p>
          )}
        </div>
      )}
      {subtitle && (
        <p className="loading-subtitle">
          {subtitle}
        </p>
      )}
    </div>
  );
}